export const SIDER_MENU_WIDTH = 200
export const SIDER_MENU_WIDTH_COLLAPSED = 48
export const GLOBAL_HEADER_HEIGHT = 48
